














import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
import EventCardLabel from './EventCardLabel.vue';
import OfferEvent from '@core/models/offer/OfferEvent';
import { getFlagByCategory } from '@sportOfferFederation/flags/flagMapping';
import { getTournamentName } from '@sportOfferFederation/bet-builder/utils/getTournamentName';

const maxLineLength = 47;

export default defineComponent({
    name: 'EventCardTitle',
    props: {
        event: {
            type: Object as PropType<OfferEvent>,
            required: true,
        },
    },
    setup(props) {
        // For some tournaments, the name is too long and it breaks betslip preview layout
        const tournamentName = computed(() => {
            const shortTournamentName = getTournamentName(props.event);

            const { sportName, categoryName } = props.event;

            const totalLength = sportName.length + (categoryName ?? '').length + shortTournamentName.length;
            if (totalLength > maxLineLength) {
                const diff = totalLength - maxLineLength;
                const sliceLength = shortTournamentName.length - diff;
                return `${shortTournamentName.slice(0, sliceLength)}\u2026`;
            }
            return shortTournamentName;
        });

        return {
            tournamentName,
            flagByCategory: computed(() => getFlagByCategory(props.event.categoryId)),
        };
    },
    components: {
        EventCardLabel,
    },
});
